// extracted by mini-css-extract-plugin
export default {"sub-header":"Sub-Header_sub-header__5sjx0","sub-container":"Sub-Header_sub-container__c+oJI"};